import {
	TITLE_HEADER_PENDING_DELIVERIES_MODULE_ID,
} from 'root/src/shared/descriptions/modules/moduleIds'

export default {
	[TITLE_HEADER_PENDING_DELIVERIES_MODULE_ID]: {
		moduleType: 'bannerHeader',
		bannerSubText: 'Approve these clips to automatically send out rewards',
	},
}
